import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { Role } from "../models/Jwt";
import { LoginResponse } from "../models/LoginResponse";

interface AuthState {
  user?: LoginResponse;
  role?: Role;
  setAuth: (user: LoginResponse, role: Role) => void;
  logout: () => void;
}

const useAuthState = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        setAuth: (user, role) => set({ user, role }),
        logout: () => set({ role: undefined, user: undefined }),
      }),
      {
        name: "auth-state",
      },
    ),
  ),
);

export default useAuthState;
